/* eslint-disable no-unused-vars */
import { ICommonWPClass, IExpressAvailability, IRecentlyEndedWP, IScratchpayRenewalPending, IUpdatePaymentMethod }
  from "../../services/get-alerts/get-alerts.interface";

import { actionTypes } from "./combined-alerts-data.actions";


export interface ICombinedAlertsData {
  isDuplicateAccount: boolean,
  shouldShowWellnessUpSell: boolean,
  shouldShowPrequalification: boolean,
  urgentVisitUpSell: boolean,
  isExpressEligible: IExpressAvailability[],
  updatePaymentMethod: IUpdatePaymentMethod[],
  alertsDataUpdated: boolean,
  endsSoonWPData: ICommonWPClass[],
  recentlyEndedWPData: ICommonWPClass[],
  failedRenewalsAfterGracePeriodWPData: ICommonWPClass[],
  recentRenewedWPData: ICommonWPClass[],
  failedRenewalsWPData: ICommonWPClass[],
  failedRenewalsWithGracePeriodWPData: ICommonWPClass[],
  scratchpayRenewalPending: IScratchpayRenewalPending[],
  referralUpSell: boolean,
}

const initialState: ICombinedAlertsData = {
  isDuplicateAccount: false,
  shouldShowWellnessUpSell: false,
  shouldShowPrequalification: false,
  urgentVisitUpSell: false,
  isExpressEligible: [],
  updatePaymentMethod: [],
  alertsDataUpdated: false,
  endsSoonWPData: [],
  recentlyEndedWPData: [],
  failedRenewalsAfterGracePeriodWPData: [],
  recentRenewedWPData: [],
  failedRenewalsWPData: [],
  failedRenewalsWithGracePeriodWPData: [],
  scratchpayRenewalPending: [],
  referralUpSell: false,
};

type CombinedAlertsAction =
  | { type: typeof actionTypes.SET_IS_DUPLICATE_ACCOUNT; payload: boolean }
  | { type: typeof actionTypes.SET_SHOULD_SHOW_WELLNESS_UPSELL; payload: boolean }
  | { type: typeof actionTypes.SET_SHOULD_SHOW_PREQUALIFICATION; payload: boolean }
  | { type: typeof actionTypes.SET_SHOW_URGENT_VISIT_UPSELL; payload: boolean }
  | { type: typeof actionTypes.SET_IS_EXPRESS_ELIGIBLE; payload: IExpressAvailability[] }
  | { type: typeof actionTypes.SET_UPDATE_PAYMENT_METHOD; payload: IUpdatePaymentMethod[] }
  | { type: typeof actionTypes.SET_RECENTLY_ENDED_WP_DATA; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_FAILED_RENEWAL_AFTER_GRACE; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_FAILED_RENEWAL_WITH_GRACE; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_RECENT_RENEWED_WP_DATA; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_ENDS_SOON_WP_DATA; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_FAILED_RENEWAL_WP_DATA; payload: ICommonWPClass[] }
  | { type: typeof actionTypes.SET_ALERTS_DATA_UPDATED; payload: boolean }
  | { type: typeof actionTypes.SET_REFERRAL_UPSELL; payload: boolean }
  | { type: typeof actionTypes.SET_SCRATCHPAY_RENEWAL_PENDING; payload: IScratchpayRenewalPending[] };


export const combinedAlertsDataReducer = (
  state: ICombinedAlertsData = initialState,
  action: CombinedAlertsAction,
): ICombinedAlertsData => {
  switch (action.type) {
  // non wellness alerts
  case actionTypes.SET_IS_DUPLICATE_ACCOUNT:
    return { ...state, isDuplicateAccount: action.payload };
  case actionTypes.SET_SHOULD_SHOW_WELLNESS_UPSELL:
    return { ...state, shouldShowWellnessUpSell: action.payload };
  case actionTypes.SET_SHOULD_SHOW_PREQUALIFICATION:
    return { ...state, shouldShowPrequalification: action.payload };
  case actionTypes.SET_SHOW_URGENT_VISIT_UPSELL:
    return { ...state, urgentVisitUpSell: action.payload };
  case actionTypes.SET_IS_EXPRESS_ELIGIBLE:
    return { ...state, isExpressEligible: action.payload };
  case actionTypes.SET_UPDATE_PAYMENT_METHOD:
    return { ...state, updatePaymentMethod: action.payload };
  // wellness alerts
  case actionTypes.SET_RECENTLY_ENDED_WP_DATA:
    return { ...state, recentlyEndedWPData: action.payload };
  case actionTypes.SET_FAILED_RENEWAL_AFTER_GRACE:
    return { ...state, failedRenewalsAfterGracePeriodWPData: action.payload };
  case actionTypes.SET_FAILED_RENEWAL_WITH_GRACE:
    return { ...state, failedRenewalsWithGracePeriodWPData: action.payload };
  case actionTypes.SET_RECENT_RENEWED_WP_DATA:
    return { ...state, recentRenewedWPData: action.payload };
  case actionTypes.SET_ENDS_SOON_WP_DATA:
    return { ...state, endsSoonWPData: action.payload };
  case actionTypes.SET_FAILED_RENEWAL_WP_DATA:
    return { ...state, failedRenewalsWPData: action.payload };
  case actionTypes.SET_REFERRAL_UPSELL:
    return { ...state, referralUpSell: action.payload };
  case actionTypes.SET_SCRATCHPAY_RENEWAL_PENDING:
    return { ...state, scratchpayRenewalPending: action.payload };
  // store status update
  case actionTypes.SET_ALERTS_DATA_UPDATED:
    return { ...state, alertsDataUpdated: action.payload };
  default:
    return state;
  }
};

